import { PropTypes } from "prop-types"
import ReactCountryFlag from "react-country-flag"

export default function Flag(props) {
  const { countryCode, style, ...rest } = props

  const styles = {
    height: "unset",
    width: "1em",
    verticalAlign: "baseline",
    ...style
  }

  return <ReactCountryFlag countryCode={countryCode} style={styles} {...rest} />
}

Flag.propTypes = {
  countryCode: PropTypes.string.isRequired,
  style: PropTypes.objectOf(PropTypes.string)
}
